import { Component } from '@angular/core';

@Component({
  selector: 'app-form-wrapper',
  standalone: false,
  template: `
    <p-fluid>
      <div class="flex flex-col items-center gap-4 w-full">
        <ng-content></ng-content>
      </div>
    </p-fluid>
  `,
})
export class FormWrapperComponent {}
